import * as React from "react";
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
var _ = require("lodash");

class Table extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            currentPage: 1
        };

        this._onPageChange = this._onPageChange.bind(this);
        this._onPageChange = this._onPageChange.bind(this);
    }

    _getDefaultSorter (columnName) {
        return function (a, b, order) {
            var stringSort = function (valueA, valueB) {
                valueA = valueA || '';
                valueB = valueB || '';

                return String(valueA).toLowerCase().localeCompare(String(valueB).toLowerCase());
            };

            var numericSort = function (valueA, valueB) {
                valueA = valueA || 0;
                valueB = valueB || 0;

                return (valueA == valueB) ? 0 : ((valueA > valueB) ? 1 : -1);
            };

            var dateSort = function (valueA, valueB) {
                valueA = valueA || '';
                valueB = valueB || '';

                var result;

                var dateA = Date.parse(valueA);
                var dateB = Date.parse(valueB);

                if (dateA && dateB) {
                    if (dateA == dateB) {
                        result = 0;
                    } else {
                        result = (dateA >= dateB) ? 1 : -1;
                    }
                } else if (dateA && !dateB) {
                    result = -1;
                } else if (!dateA && dateB) {
                    result = 1;
                }

                return result;
            };

            var nullIfUndefined = function (row) {
                return (row || {})[columnName] || null;
            };

            var result = 0;
            var valueA = nullIfUndefined(a);
            var valueB = nullIfUndefined(b);

            if (valueA instanceof Date || valueB instanceof Date) { // date compare
                result = dateSort(valueA, valueB);
            } else if (valueA instanceof Number && valueB instanceof Number) { // numeric compare
                result = numericSort(valueA, valueB);
            } else { // string compare
                result = stringSort(valueA, valueB);
            }

            return order === 'desc' ? -result : result;
        };
    }

    _getDefaultOptions () {
        return {
            sizePerPage: 10,
            onPageChange: this._onPageChange,
            page: this.state.currentPage
        };
    }

    _getDefaultProps () {
        return {
            condensed: true,
            hover: true,
            pagination: false,
            responsive: true,
            striped: true
        };
    }

    _getTransformedProps () {
        return _.omit(this.props, [
            "title",
            "subtitle",
            "cssClass"
        ]);
    }

    _getTransformedColumns () {
        var self = this;
        return this.props.columns.map(sourceColumn => {
            var column = Object.assign({}, sourceColumn);

            if (column.dataSort && !column.sortFunc) {
                column.sortFunc = self._getDefaultSorter(column.sortKey || column.dataField);
            }

            var colFormat = column.dataFormat;

            column.dataFormat = function (cell, row) {
                var cellValue = cell;

                if (colFormat) {
                    cellValue = colFormat(cell, row);
                }

                return (<span className={column.dataField + "Text"}>{cellValue}</span>);
            };

            if (column.width instanceof Number) {
                column.width = String(column.width);
            }

            if (!column.label) {
                column.label = column.dataField;
            }

            return column;
        });
    }

    _onPageChange (page) {
        this.setState({
            currentPage: page
        });
    }

    render () {
        var innerTableProps = Object.assign(this._getDefaultProps(), this._getTransformedProps());
        innerTableProps.options = Object.assign(this._getDefaultOptions(), innerTableProps.options || {});

        var Heading;
        if (this.props.title) {
            Heading = (<h2 className="react-bs-table-heading">{this.props.title}</h2>);
        }

        var SubHeading;
        if (this.props.subtitle) {
            SubHeading = (<div className="tableSubtitle subtitle">{this.props.subtitle}</div>);
        }

        var Columns = this._getTransformedColumns().map((column) => {
            return (
                <TableHeaderColumn {...column} key={column.dataField}>
                    {column.label}
                </TableHeaderColumn>
            );
        });

        var cssClass = this.props.cssClass || "";

        if (innerTableProps.sort !== undefined) {
            innerTableProps.options.sortName = this.props.sort;
            innerTableProps.options.sortOrder = "asc";
        }

        if (innerTableProps.data.length <= innerTableProps.options.sizePerPage) {
            innerTableProps.pagination = false;
        }

        var tableClasses = [];
        if (innerTableProps.responsive) {
            tableClasses.push("table-responsive react-bs-table-responsive");
        }

        var TableView = (
            <div className={tableClasses.join(" ")}>
                <BootstrapTable {...innerTableProps}>
                    {Columns}
                </BootstrapTable>
            </div>
        );

        return (
            <div className={"jsxTableControl tableJsx " + cssClass}>
                {Heading}
                {SubHeading}
                {TableView}
            </div>
        );
    }
}

export default Table;
